const gr = {
  brand: "DIGITAL COMPANY",
  brandLine: "B2B DIGITAL & AI SOLUTIONS",
  tagline: "Από την πρώτη προβολή μέχρι την πώληση.",
  nav: {
    home: "Αρχική",
    services: "Υπηρεσίες",
    projects: "Έργα",
    solutions: "Λύσεις",
    whyB2b: "Γιατί B2B;",
    about: "Σχετικά",
    contact: "Επικοινωνία",
    cta: "Ζητήστε προσφορά",
    dropdown: [
      { label: "B2B Advertising", to: "/b2b-advertising" },
      { label: "Websites", to: "/websites" },
      { label: "CRM", to: "/crm" },
      { label: "AI Secretary", to: "/ai-secretary" },
      { label: "Business Email", to: "/business-email" },
    ],
  },
  hero: {
    label: "B2B DIGITAL & AI SOLUTIONS",
    lines: ["Η τεχνολογία πίσω από", "την ανάπτυξη της B2B", "επιχείρησής σας."],
    sub: "B2B Advertising, Websites, CRM και AI εργαλεία που συνεργάζονται σε ένα ολοκληρωμένο ψηφιακό σύστημα.",
    cta1: "Ζητήστε δωρεάν αξιολόγηση",
    cta2: "Δείτε τις λύσεις μας",
    strip: "B2B ADS • WEB • CRM • AI • BUSINESS EMAIL",
    flow: ["AD", "WEBSITE", "LEAD", "AI", "CRM", "SALE"],
    flowLabels: ["B2B Ad", "Website", "Lead", "AI Secretary", "CRM", "Πώληση"],
  },
  marquee: ["ΑΠΟ ΤΗΝ ΠΡΩΤΗ ΠΡΟΒΟΛΗ ΜΕΧΡΙ ΤΗΝ ΠΩΛΗΣΗ", "B2B ADVERTISING", "WEBSITES", "CRM", "AI SECRETARY", "BUSINESS EMAIL"],
  services: {
    eyebrow: "ΥΠΗΡΕΣΙΕΣ",
    title: "Πέντε λύσεις. Ένα ψηφιακό οικοσύστημα.",
    sub: "Δεν πουλάμε αποσπασματικές υπηρεσίες. Σχεδιάζουμε συστήματα που συνεργάζονται — από την προβολή μέχρι την πώληση.",
    cards: [
      { num: "01", title: "B2B ADVERTISING", desc: "Στοχευμένη διαφήμιση για νέες επιχειρηματικές ευκαιρίες.", to: "/b2b-advertising" },
      { num: "02", title: "WEBSITES", desc: "Ελληνικές και αγγλικές ιστοσελίδες σχεδιασμένες για επιχειρήσεις.", to: "/websites" },
      { num: "03", title: "CRM", desc: "Οργανώστε leads, πελάτες και πωλήσεις.", to: "/crm" },
      { num: "04", title: "AI SECRETARY", desc: "Η έξυπνη πρώτη γραμμή επικοινωνίας της επιχείρησής σας.", to: "/ai-secretary" },
      { num: "05", title: "BUSINESS EMAIL", desc: "Επαγγελματική επικοινωνία με το δικό σας domain.", to: "/business-email" },
    ],
  },
  flow: {
    eyebrow: "ΤΟ ΟΙΚΟΣΥΣΤΗΜΑ",
    title: "Από την πρώτη προβολή μέχρι την πώληση.",
    copy: "Δεν αντιμετωπίζουμε τη διαφήμιση, την ιστοσελίδα, την τεχνητή νοημοσύνη και το CRM ως ανεξάρτητα εργαλεία. Τα συνδέουμε σε ένα ενιαίο ψηφιακό οικοσύστημα που βοηθά την επιχείρησή σας να προσελκύει νέες επαγγελματικές επαφές, να τις εξυπηρετεί, να τις οργανώνει και να τις μετατρέπει σε εμπορικές ευκαιρίες.",
    steps: ["B2B ADS", "WEBSITE", "LEAD", "AI SECRETARY", "CRM", "FOLLOW-UP", "CUSTOMER"],
  },
  work: {
    eyebrow: "OUR WORK",
    title: "Από το concept στην πραγματική εφαρμογή.",
    sub: "Ενδεικτικά websites, e-commerce και web applications που έχουμε ήδη δημιουργήσει.",
    cta: "Δείτε το Project",
    allCta: "Δείτε όλα τα έργα",
  },
  ads: {
    eyebrow: "01 — B2B ADVERTISING",
    title: "Δεν κυνηγάμε followers. Δημιουργούμε επιχειρηματικές ευκαιρίες.",
    copy: "Η B2B διαφήμιση έχει διαφορετική λογική από το απλό B2C social media marketing. Δεν μετράμε likes και engagement — σχεδιάζουμε καμπάνιες σε Facebook, Instagram και Meta Ads που φέρνουν B2B leads, αιτήματα προσφοράς και επαγγελματικές συνεργασίες.",
    bullets: ["B2B Leads", "Νέοι επαγγελματίες πελάτες", "Αιτήματα προσφοράς", "Dealers & Distributors", "Wholesalers", "Commercial opportunities"],
    channels: ["Facebook", "Instagram", "Meta Ads"],
    cta: "Συζητήστε την καμπάνια σας",
  },
  web: {
    eyebrow: "02 — WEBSITES & WEB DEVELOPMENT",
    title: "Η επιχείρησή σας στην Ελλάδα και το εξωτερικό.",
    copy: "Δημιουργούμε ελληνικές και αγγλικές εταιρικές ιστοσελίδες που παρουσιάζουν επαγγελματικά την επιχείρησή σας στην ελληνική και τη διεθνή αγορά.",
    message: "Η ιστοσελίδα σας δεν είναι απλώς η ψηφιακή σας παρουσία. Είναι εργαλείο πωλήσεων.",
    chips: ["Exporters", "Manufacturers", "Producers", "Wholesalers", "Suppliers", "B2B Service Companies"],
    cta: "Δείτε τις λύσεις Web",
  },
  ai: {
    eyebrow: "04 — AI SECRETARY",
    title: "Η επιχείρησή σας διαθέσιμη 24/7.",
    sub: "Από την πρώτη ερώτηση μέχρι το CRM, αυτόματα.",
    copy: "Ο AI Γραμματέας δεν είναι ένα απλό chatbot. Είναι ένας AI Business Assistant που, ανάλογα με την υλοποίηση, υποστηρίζει την πρώτη γραμμή επικοινωνίας της επιχείρησής σας.",
    bullets: ["Απάντηση συχνών ερωτήσεων", "Lead capture & qualification", "Καταγραφή αιτημάτων", "Appointment requests", "Routing αιτημάτων", "Σύνδεση με CRM", "Ειδοποίηση πωλητή", "Follow-up workflows", "24/7 digital availability"],
    cta: "Ζητήστε Demo",
    chat: {
      customer: "Καλησπέρα. Ενδιαφέρομαι για επαγγελματική συνεργασία.",
      ai: "Βεβαίως. Ποια είναι η επωνυμία της εταιρείας σας;",
      company: "ABC INDUSTRIES",
      email: "sales@example.gr",
      interest: "B2B Partnership",
      status: "QUALIFIED LEAD",
      action: "ADDED TO CRM",
      typing: "ο AI Γραμματέας γράφει…",
      demo: "Ενδεικτική συνομιλία επίδειξης",
    },
  },
  crm: {
    eyebrow: "03 — BUSINESS CRM",
    title: "Κάθε lead. Κάθε επικοινωνία. Κάθε ευκαιρία. Σε ένα σημείο.",
    sub: "Μην αφήνετε καμία επαγγελματική ευκαιρία να χάνεται.",
    copy: "Οργανώστε πελάτες, leads, ευκαιρίες και πωλήσεις σε ένα ενιαίο σύστημα — από το πρώτο contact μέχρι το κλείσιμο της συνεργασίας.",
    stats: ["LEADS", "ACTIVE OPPORTUNITIES", "FOLLOW-UPS", "DEALS WON"],
    pipeline: ["NEW LEAD", "CONTACTED", "MEETING", "OFFER", "WON"],
    demo: "Ενδεικτικά demo δεδομένα — όχι πραγματικά αποτελέσματα πελατών.",
    cta: "Ζητήστε παρουσίαση CRM",
  },
  aicrm: {
    eyebrow: "AI + CRM",
    title: "AI που συνεργάζεται με τις πωλήσεις σας.",
    copy: "Ο AI Γραμματέας μπορεί να λειτουργεί ως το πρώτο ψηφιακό σημείο επικοινωνίας της επιχείρησης, να συλλέγει τις απαραίτητες πληροφορίες και, όπου υπάρχει η σχετική διασύνδεση, να τις μεταφέρει στο CRM ώστε η ομάδα πωλήσεων να συνεχίζει την επικοινωνία.",
    steps: ["Incoming Lead", "AI Conversation", "Contact Information", "CRM", "Sales Representative"],
    cta: "Δείτε πώς λειτουργεί",
  },
  webapps: {
    eyebrow: "WEB APPLICATIONS",
    title: "Πέρα από websites — ψηφιακά εργαλεία για την επιχείρησή σας.",
    copy: "Σχεδιάζουμε και αναπτύσσουμε custom web εφαρμογές γύρω από πραγματικές επιχειρηματικές διαδικασίες.",
    bullets: ["Business Web Applications", "Management Applications", "Internal Business Tools", "Customer Portals", "Sales Applications", "Digital Platforms", "Custom business workflows"],
    exampleLabel: "Πραγματικό παράδειγμα",
    example: "ESPAMANAGER.GR — πλατφόρμα διαχείρισης αιτήσεων χρηματοδότησης με αυτόματο έλεγχο δικαιολογητικών.",
    cta: "Δείτε το project",
  },
  email: {
    eyebrow: "05 — BUSINESS EMAIL",
    title: "Επαγγελματική επικοινωνία με την εταιρική σας ταυτότητα.",
    copy: "Επαγγελματικό εταιρικό email μέσω mail server infrastructure, ως συμπληρωματικό κομμάτι του ψηφιακού σας οικοσυστήματος.",
    examples: ["info@company.gr", "sales@company.gr", "name@company.gr"],
    bullets: ["Email hosting", "Εταιρικοί λογαριασμοί email", "Webmail", "Mobile & desktop access", "Email configuration", "Account management", "Τεχνική υποστήριξη"],
    cta: "Ζητήστε προσφορά",
  },
  b2b: {
    eyebrow: "ΓΙΑΤΙ B2B",
    title: "100% B2B προσανατολισμός.",
    copy: "Οι πωλήσεις μεταξύ επιχειρήσεων λειτουργούν διαφορετικά. Μεγαλύτερος κύκλος πώλησης, περισσότερα σημεία επικοινωνίας, διαφορετικοί decision makers και ανάγκη για οργανωμένο follow-up. Για αυτό σχεδιάζουμε τις ψηφιακές μας λύσεις γύρω από τις πραγματικές ανάγκες μιας B2B εμπορικής διαδικασίας.",
    highlights: ["TARGETING", "LEADS", "FOLLOW-UP", "CRM", "AI", "SALES"],
  },
  ecosystem: {
    eyebrow: "ΤΟ ΟΙΚΟΣΥΣΤΗΜΑ",
    title: "Ένα οικοσύστημα. Πέντε ψηφιακές λύσεις.",
    copy: "Κάθε υπηρεσία λειτουργεί αυτόνομα — αλλά η πραγματική δύναμη βρίσκεται στον τρόπο που συνδέονται.",
    center: "YOUR BUSINESS",
    nodes: ["ADVERTISING", "WEBSITE", "AI", "CRM", "EMAIL"],
  },
  usecases: {
    eyebrow: "USE CASES",
    title: "Λύσεις σχεδιασμένες γύρω από την επιχείρησή σας.",
    cards: [
      { title: "MANUFACTURER", items: ["Website GR/EN", "B2B Lead Generation"] },
      { title: "WHOLESALER", items: ["Advertising", "CRM"] },
      { title: "EXPORT COMPANY", items: ["English Website", "Digital Presence"] },
      { title: "B2B SERVICES", items: ["Website", "AI Secretary", "CRM"] },
      { title: "SALES TEAM", items: ["CRM", "Lead Management", "Follow-up"] },
    ],
  },
  packages: {
    eyebrow: "ΠΑΚΕΤΑ",
    title: "Δομημένες λύσεις για κάθε στάδιο ανάπτυξης.",
    sub: "Χωρίς δημοσιευμένες τιμές — κάθε πρόταση διαμορφώνεται γύρω από τις πραγματικές ανάγκες της επιχείρησής σας.",
    badge: "COMPLETE SOLUTION",
    cta: "Ζητήστε προσφορά",
    ctaDemo: "Ζητήστε παρουσίαση",
    list: [
      { name: "B2B PRESENCE", features: ["Corporate Website", "GR / EN", "Business Email", "Contact Forms", "Analytics"], highlight: false },
      { name: "B2B GROWTH", features: ["Website", "B2B Advertising", "Landing Pages", "Lead Generation", "Analytics", "Reporting"], highlight: false },
      { name: "B2B COMPLETE", features: ["Website", "B2B Advertising", "AI Secretary", "CRM", "Business Email", "Lead Management", "Sales Pipeline", "Integrations", "Reporting"], highlight: true },
    ],
  },
  finalCta: {
    title: "Ας σχεδιάσουμε το επόμενο ψηφιακό βήμα της επιχείρησής σας.",
    sub: "Στείλτε μας το αίτημά σας και θα επικοινωνήσουμε μαζί σας.",
  },
  form: {
    name: "Ονοματεπώνυμο",
    company: "Επωνυμία",
    email: "Email",
    phone: "Τηλέφωνο",
    website: "Website",
    servicesLabel: "Υπηρεσίες που σας ενδιαφέρουν",
    services: ["B2B Advertising", "Website", "Web Application", "CRM", "AI Secretary", "Business Email", "Ολοκληρωμένη λύση"],
    message: "Πείτε μας λίγα λόγια για την επιχείρησή σας.",
    privacy: "Συναινώ στην επεξεργασία των στοιχείων μου σύμφωνα με την Πολιτική Απορρήτου.",
    submit: "Αποστολή αιτήματος",
    sending: "Αποστολή…",
    success: "Το αίτημά σας εστάλη. Θα επικοινωνήσουμε σύντομα μαζί σας.",
    error: "Κάτι πήγε στραβά. Δοκιμάστε ξανά.",
    required: "Συμπληρώστε τα υποχρεωτικά πεδία.",
  },
  footer: {
    line: "B2B Digital & AI Solutions",
    servicesTitle: "ΥΠΗΡΕΣΙΕΣ",
    services: [
      { label: "B2B Advertising", to: "/b2b-advertising" },
      { label: "Websites", to: "/websites" },
      { label: "Web Applications", to: "/websites" },
      { label: "CRM", to: "/crm" },
      { label: "AI Secretary", to: "/ai-secretary" },
      { label: "Business Email", to: "/business-email" },
    ],
    companyTitle: "ΕΤΑΙΡΕΙΑ",
    company: [
      { label: "Σχετικά", to: "/about" },
      { label: "Έργα", to: "/projects" },
      { label: "Επικοινωνία", to: "/contact" },
    ],
    legalTitle: "LEGAL",
    legal: [
      { label: "Πολιτική Απορρήτου", to: "/privacy-policy" },
      { label: "Πολιτική Cookies", to: "/cookies" },
    ],
    rights: "© 2026 DIGITAL COMPANY. Με επιφύλαξη παντός δικαιώματος.",
  },
  cookieConsent: {
    text: "Χρησιμοποιούμε απολύτως απαραίτητα cookies για τη λειτουργία του site και — μόνο με τη συγκατάθεσή σας — cookies ανάλυσης.",
    accept: "Αποδοχή όλων",
    essential: "Μόνο απαραίτητα",
  },
  projectsPage: {
    title: "Τα έργα μας",
    sub: "Από εταιρικές ιστοσελίδες και ηλεκτρονικά καταστήματα μέχρι web applications, δημιουργούμε ψηφιακές λύσεις γύρω από πραγματικές επιχειρηματικές ανάγκες.",
    visit: "Επίσκεψη",
  },
  projectDetail: {
    back: "Πίσω στα έργα",
    type: "ΤΥΠΟΣ",
    overview: "ΠΕΡΙΓΡΑΦΗ",
    services: "ΥΠΗΡΕΣΙΕΣ",
    website: "WEBSITE",
    visit: "Επισκεφθείτε το website",
    cta: "Θέλετε κάτι αντίστοιχο για την επιχείρησή σας;",
    ctaBtn: "Μιλήστε μαζί μας",
  },
  solutions: {
    eyebrow: "ΛΥΣΕΙΣ",
    title: "Ψηφιακές λύσεις γύρω από τη B2B εμπορική διαδικασία.",
    sub: "Συνδυάζουμε advertising, web, AI και CRM σε πρακτικές λύσεις ανάλογα με τον τύπο και το στάδιο της επιχείρησής σας.",
  },
  about: {
    eyebrow: "ΣΧΕΤΙΚΑ",
    title: "Marketing, Technology & AI σε ένα ενιαίο B2B οικοσύστημα.",
    copy: "Η DIGITAL COMPANY είναι ελληνική εταιρεία B2B Digital & AI Technology Solutions. Σχεδιάζουμε και αναπτύσσουμε ψηφιακά συστήματα για επιχειρήσεις που πουλάνε σε άλλες επιχειρήσεις — από την πρώτη προβολή μέχρι την πώληση.",
    copy2: "Η δουλειά μας αποτυπώνεται σε πραγματικά, ολοκληρωμένα projects — από web applications όπως το ESPAMANAGER.GR μέχρι δίγλωσσες εταιρικές ιστοσελίδες και e-commerce.",
    principles: [
      { title: "B2B FIRST", desc: "Σχεδιάζουμε αποκλειστικά γύρω από τις ανάγκες επιχειρήσεων που πουλάνε σε άλλες επιχειρήσεις." },
      { title: "BUSINESS FOCUS", desc: "Κάθε λύση αξιολογείται με επιχειρηματικά κριτήρια: leads, πωλήσεις, οργάνωση." },
      { title: "INTEGRATED SOLUTIONS", desc: "Advertising, web, AI και CRM λειτουργούν ως ένα ενιαίο σύστημα." },
      { title: "TECHNOLOGY", desc: "Σύγχρονες τεχνολογίες και αξιόπιστη υποδομή σε κάθε υλοποίηση." },
      { title: "AUTOMATION", desc: "Αυτοματοποιούμε επαναλαμβανόμενες διαδικασίες ώστε η ομάδα σας να εστιάζει στις πωλήσεις." },
      { title: "DIGITAL DEVELOPMENT", desc: "Από corporate websites μέχρι custom web applications και digital platforms." },
    ],
    workTitle: "Απόδειξη στην πράξη.",
    workCopy: "Δείτε πραγματικά projects που έχουμε ήδη σχεδιάσει και αναπτύξει.",
    workCta: "Δείτε τα έργα μας",
  },
  contactPage: {
    eyebrow: "ΕΠΙΚΟΙΝΩΝΙΑ",
    title: "Μιλήστε μαζί μας.",
    sub: "Πείτε μας τι χρειάζεται η επιχείρησή σας και θα σας προτείνουμε την κατάλληλη ψηφιακή λύση.",
    addressLabel: "ΔΙΕΥΘΥΝΣΗ",
    address: "Καρτερού 58",
    city: "Ηράκλειο Κρήτης",
    phoneLabel: "ΤΗΛΕΦΩΝΟ",
    phone: "6989 164 257",
    emailLabel: "EMAIL",
    email: "info@digital-company.gr",
    formNote: "Προτιμάτε γραπτώς;",
    formLink: "Στείλτε μας αίτημα μέσω της φόρμας",
    mapTitle: "Χάρτης — Καρτερού 58, Ηράκλειο Κρήτης",
  },
  spages: {
    "b2b-advertising": {
      eyebrow: "01 — ΥΠΗΡΕΣΙΑ",
      title: "B2B Advertising",
      lead: "Στοχευμένες καμπάνιες σε Facebook, Instagram και Meta Ads με έναν στόχο: πραγματικές επιχειρηματικές ευκαιρίες — όχι απλή αλληλεπίδραση.",
      message: "Δεν κυνηγάμε followers. Δημιουργούμε επιχειρηματικές ευκαιρίες.",
      blocks: [
        { title: "Στόχευση B2B κοινού", desc: "Καμπάνιες σχεδιασμένες για decision makers: CEO, ιδιοκτήτες, Commercial Directors, Sales & Marketing Managers, Export Managers." },
        { title: "Lead generation, όχι vanity metrics", desc: "Ο στόχος είναι B2B leads, αιτήματα προσφοράς, dealers, distributors, wholesalers και επαγγελματικές συνεργασίες — όχι likes και followers." },
        { title: "Σύνδεση με το οικοσύστημα", desc: "Κάθε lead από την καμπάνια μπορεί να οδηγείται στο website σας, να εξυπηρετείται από τον AI Γραμματέα και να καταχωρείται στο CRM σας." },
      ],
      bullets: ["Facebook Ads", "Instagram Ads", "Meta Ads", "B2B Leads", "Αιτήματα προσφοράς", "Dealers & Distributors", "Wholesalers", "Commercial opportunities"],
      cta: "Συζητήστε την καμπάνια σας",
    },
    websites: {
      eyebrow: "02 — ΥΠΗΡΕΣΙΑ",
      title: "Websites & Web Development",
      lead: "Επαγγελματικές ιστοσελίδες για επιχειρήσεις — σχεδιασμένες ως εργαλείο πωλήσεων, όχι απλή ψηφιακή παρουσία.",
      message: "Η ιστοσελίδα σας δεν είναι απλώς η ψηφιακή σας παρουσία. Είναι εργαλείο πωλήσεων.",
      blocks: [
        { title: "GR / EN Website Development", desc: "Ελληνικά, αγγλικά και δίγλωσσα websites για επιχειρήσεις που απευθύνονται στην ελληνική και τη διεθνή αγορά — εξαγωγείς, παραγωγοί, χονδρέμποροι, προμηθευτές." },
        { title: "Σχεδιασμένα για leads", desc: "Contact forms, lead generation forms, request-a-quote ροές και landing pages που μετατρέπουν την επισκεψιμότητα σε εμπορικά αιτήματα." },
        { title: "Πλήρεις διασυνδέσεις", desc: "Meta Pixel, Analytics, CRM integration, Business Email και SEO-ready δομή — έτοιμα να συνδεθούν με το υπόλοιπο ψηφιακό σας οικοσύστημα." },
      ],
      bullets: ["Corporate Websites", "B2B Websites", "Δίγλωσσα GR / EN", "Landing Pages", "Web Applications", "Digital Platforms", "E-commerce", "Responsive & Mobile Optimization", "Request a Quote", "SEO-ready structure"],
      cta: "Δημιουργήστε το νέο σας website",
    },
    crm: {
      eyebrow: "03 — ΥΠΗΡΕΣΙΑ",
      title: "Business CRM",
      lead: "Οργανώστε πελάτες, leads, ευκαιρίες και πωλήσεις σε ένα ενιαίο σύστημα — από το πρώτο contact μέχρι το κλείσιμο της συνεργασίας.",
      message: "Κάθε lead. Κάθε επικοινωνία. Κάθε ευκαιρία. Σε ένα σημείο.",
      blocks: [
        { title: "Sales pipeline", desc: "Παρακολουθήστε κάθε ευκαιρία από το NEW LEAD μέχρι το WON: CONTACTED → MEETING → OFFER → WON, με πλήρες ιστορικό κάθε πελάτη." },
        { title: "Οργάνωση ομάδας πωλήσεων", desc: "Tasks, notes, meetings, reminders και follow-ups ανατεθειμένα ανά μέλος της ομάδας — τίποτα δεν χάνεται." },
        { title: "Reports & dashboard", desc: "Καθαρή εικόνα των πωλήσεών σας: leads, ενεργές ευκαιρίες, follow-ups και κερδισμένες συμφωνίες σε ένα dashboard." },
      ],
      bullets: ["Customers & Companies", "Leads & Contacts", "Opportunities & Deals", "Sales Pipeline", "Tasks & Reminders", "Meetings & Notes", "Offers", "Lead & customer history", "Sales team management", "Reports & Dashboard"],
      cta: "Ζητήστε παρουσίαση CRM",
    },
    "ai-secretary": {
      eyebrow: "04 — ΥΠΗΡΕΣΙΑ",
      title: "AI Γραμματέας",
      lead: "Ένας AI Business Assistant που λειτουργεί ως η πρώτη ψηφιακή γραμμή επικοινωνίας της επιχείρησής σας — όχι απλώς ένα chatbot.",
      message: "Η επιχείρησή σας διαθέσιμη 24/7.",
      message2: "Από την πρώτη ερώτηση μέχρι το CRM, αυτόματα.",
      blocks: [
        { title: "Εξυπηρέτηση ενδιαφερομένων", desc: "Απαντά σε συχνές ερωτήσεις, δίνει βασικές πληροφορίες και καταγράφει αιτήματα — ακόμη και εκτός ωραρίου." },
        { title: "Lead capture & qualification", desc: "Συλλέγει στοιχεία επικοινωνίας, κατανοεί το αίτημα και αξιολογεί το ενδιαφέρον πριν φτάσει στην ομάδα πωλήσεων." },
        { title: "Σύνδεση με CRM", desc: "Όπου υπάρχει διασύνδεση, κάθε νέο lead καταχωρείται αυτόματα στο CRM και ο αρμόδιος πωλητής ειδοποιείται για follow-up." },
      ],
      bullets: ["Απάντηση συχνών ερωτήσεων", "Lead capture", "Lead qualification", "Καταγραφή αιτημάτων", "Appointment requests", "Routing αιτημάτων", "Σύνδεση με CRM", "Ειδοποίηση πωλητή", "Follow-up workflows", "24/7 digital availability"],
      cta: "Ζητήστε Demo",
    },
    "business-email": {
      eyebrow: "05 — ΥΠΗΡΕΣΙΑ",
      title: "Business Email",
      lead: "Επαγγελματικό εταιρικό email με το δικό σας domain, μέσω αξιόπιστης mail server infrastructure.",
      message: "Επαγγελματική επικοινωνία με την εταιρική σας ταυτότητα.",
      blocks: [
        { title: "Εταιρικοί λογαριασμοί", desc: "Διευθύνσεις όπως info@company.gr, sales@company.gr και name@company.gr που ενισχύουν την εταιρική σας ταυτότητα σε κάθε επικοινωνία." },
        { title: "Πρόσβαση παντού", desc: "Webmail, mobile και desktop access με πλήρη ρύθμιση στις συσκευές της ομάδας σας." },
        { title: "Διαχείριση & υποστήριξη", desc: "Account management, email configuration και τεχνική υποστήριξη — ως συμπληρωματική υπηρεσία του ψηφιακού σας οικοσυστήματος." },
      ],
      bullets: ["Email hosting", "Company email accounts", "Webmail", "Mobile access", "Desktop access", "Email configuration", "Account management", "Τεχνική υποστήριξη"],
      cta: "Ζητήστε προσφορά",
    },
  },
  privacy: {
    title: "Πολιτική Απορρήτου",
    updated: "Τελευταία ενημέρωση: Ιούλιος 2026",
    sections: [
      { h: "Υπεύθυνος επεξεργασίας", p: "Υπεύθυνη επεξεργασίας των προσωπικών δεδομένων που συλλέγονται μέσω του παρόντος ιστότοπου είναι η DIGITAL COMPANY (digital-company.gr), Καρτερού 58, Ηράκλειο Κρήτης. Για οποιοδήποτε θέμα απορρήτου μπορείτε να επικοινωνείτε μαζί μας στο info@digital-company.gr ή στο 6989 164 257." },
      { h: "Ποια δεδομένα συλλέγουμε", p: "Μέσω της φόρμας επικοινωνίας συλλέγουμε τα στοιχεία που μας δίνετε εσείς: ονοματεπώνυμο, επωνυμία εταιρείας, email, τηλέφωνο, ιστότοπο, υπηρεσίες ενδιαφέροντος και το μήνυμά σας. Τα δεδομένα αυτά χρησιμοποιούνται αποκλειστικά για την απάντηση στο αίτημά σας και την εμπορική μας επικοινωνία μαζί σας." },
      { h: "Νομική βάση επεξεργασίας", p: "Η επεξεργασία βασίζεται στη συγκατάθεσή σας (άρθρο 6 παρ. 1 α' GDPR), την οποία παρέχετε με το αντίστοιχο πεδίο της φόρμας, καθώς και στο έννομο συμφέρον μας για την εξυπηρέτηση επιχειρηματικών αιτημάτων." },
      { h: "Διατήρηση δεδομένων", p: "Τα δεδομένα της φόρμας διατηρούνται για όσο χρόνο απαιτείται για την εξυπηρέτηση του αιτήματός σας και την τυχόν επακόλουθη συνεργασία, και διαγράφονται ή ανωνυμοποιούνται όταν δεν είναι πλέον απαραίτητα." },
      { h: "Τα δικαιώματά σας", p: "Έχετε δικαίωμα πρόσβασης, διόρθωσης, διαγραφής, περιορισμού, φορητότητας και εναντίωσης στην επεξεργασία των δεδομένων σας, καθώς και δικαίωμα ανάκλησης της συγκατάθεσής σας ανά πάσα στιγμή. Έχετε επίσης δικαίωμα καταγγελίας στην Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (www.dpa.gr)." },
      { h: "Ασφάλεια", p: "Εφαρμόζουμε κατάλληλα τεχνικά και οργανωτικά μέτρα για την προστασία των δεδομένων σας. Δεν πωλούμε ούτε κοινοποιούμε τα στοιχεία σας σε τρίτους για δικούς τους σκοπούς." },
    ],
  },
  cookies: {
    title: "Πολιτική Cookies",
    updated: "Τελευταία ενημέρωση: Ιούλιος 2026",
    sections: [
      { h: "Τι είναι τα cookies", p: "Τα cookies είναι μικρά αρχεία κειμένου που αποθηκεύονται στη συσκευή σας κατά την επίσκεψη σε έναν ιστότοπο και βοηθούν στη λειτουργία και τη βελτίωσή του." },
      { h: "Απαραίτητα cookies", p: "Χρησιμοποιούμε απολύτως απαραίτητα cookies/μηχανισμούς αποθήκευσης για τη λειτουργία του ιστότοπου και την αποθήκευση της επιλογής συγκατάθεσής σας. Αυτά δεν απαιτούν συγκατάθεση." },
      { h: "Cookies ανάλυσης", p: "Μόνο με τη συγκατάθεσή σας, χρησιμοποιούμε cookies ανάλυσης για να κατανοούμε πώς χρησιμοποιείται ο ιστότοπος και να τον βελτιώνουμε. Μπορείτε να αλλάξετε την επιλογή σας ανά πάσα στιγμή διαγράφοντας τα δεδομένα του ιστότοπου από τον browser σας." },
      { h: "Διαχείριση συγκατάθεσης", p: "Κατά την πρώτη σας επίσκεψη εμφανίζεται banner συγκατάθεσης όπου μπορείτε να αποδεχθείτε όλα τα cookies ή μόνο τα απαραίτητα. Καμία μη απαραίτητη τεχνολογία παρακολούθησης δεν ενεργοποιείται πριν από τη συγκατάθεσή σας." },
    ],
  },
  notFound: {
    title: "Η σελίδα δεν βρέθηκε",
    sub: "Ο σύνδεσμος που ακολουθήσατε δεν αντιστοιχεί σε σελίδα.",
    cta: "Επιστροφή στην αρχική",
  },
  seo: {
    home: { title: "DIGITAL COMPANY — B2B Digital & AI Solutions", desc: "B2B Advertising, κατασκευή ιστοσελίδων GR/EN, CRM, AI Γραμματέας & Business Email σε ένα ολοκληρωμένο ψηφιακό οικοσύστημα για B2B επιχειρήσεις." },
    "b2b-advertising": { title: "B2B Advertising & Meta Ads | DIGITAL COMPANY", desc: "B2B διαφήμιση σε Facebook, Instagram & Meta Ads με στόχο B2B leads, αιτήματα προσφοράς και επαγγελματικές συνεργασίες." },
    websites: { title: "Κατασκευή Ιστοσελίδων GR/EN & Web Apps | DIGITAL COMPANY", desc: "Εταιρικές, B2B και δίγλωσσες ιστοσελίδες, landing pages, e-commerce και web applications σχεδιασμένα ως εργαλείο πωλήσεων." },
    crm: { title: "CRM Επιχειρήσεων & Πωλήσεων | DIGITAL COMPANY", desc: "Business CRM για οργάνωση leads, πελατών, ευκαιριών και sales pipeline. Κάθε ευκαιρία σε ένα σημείο." },
    "ai-secretary": { title: "AI Γραμματέας — AI Secretary | DIGITAL COMPANY", desc: "AI Business Assistant για 24/7 εξυπηρέτηση, lead capture & qualification και αυτόματη σύνδεση με το CRM σας." },
    "business-email": { title: "Business Email & Εταιρικό Email | DIGITAL COMPANY", desc: "Επαγγελματικό εταιρικό email με το δικό σας domain: hosting, webmail, mobile & desktop access και τεχνική υποστήριξη." },
    projects: { title: "Τα Έργα μας | DIGITAL COMPANY", desc: "Ενδεικτικά websites, e-commerce και web applications που έχουμε δημιουργήσει: ESPAMANAGER.GR, QALS.GR, BLOUZES4ALL.GR, NOETICALAB.GR." },
    solutions: { title: "Λύσεις B2B | DIGITAL COMPANY", desc: "Ψηφιακές λύσεις για B2B επιχειρήσεις: πακέτα B2B Presence, B2B Growth και B2B Complete με Advertising, Web, AI και CRM." },
    about: { title: "Σχετικά | DIGITAL COMPANY", desc: "Marketing, Technology & AI σε ένα ενιαίο B2B οικοσύστημα. Γνωρίστε τη φιλοσοφία της DIGITAL COMPANY." },
    contact: { title: "Επικοινωνία | DIGITAL COMPANY", desc: "Ζητήστε δωρεάν αξιολόγηση για B2B Advertising, Website, CRM, AI Secretary ή Business Email." },
    privacy: { title: "Πολιτική Απορρήτου | DIGITAL COMPANY", desc: "Πώς συλλέγουμε, επεξεργαζόμαστε και προστατεύουμε τα προσωπικά σας δεδομένα." },
    cookies: { title: "Πολιτική Cookies | DIGITAL COMPANY", desc: "Πληροφορίες για τα cookies που χρησιμοποιούμε και τη διαχείριση της συγκατάθεσής σας." },
  },
};

export default gr;
